export enum GUID_ {
   E3E990DC900441ECB664E9043B9A77B7 /*serviceLayerClientIdHeaderName*/,
   E567D0E4603F4A7580212E770DE079AA /*serviceLayerClientId*/,
   F4D970E7D2214F33B390649AA5946C1E /*serviceLayerClientSecretHeaderName*/,
   D9A8BADB30FA4EDE975EAE987AABFBD4 /*serviceLayerClientSecret*/,
   B8C119E38553467B8ED361CB1AC821C5 /*MSAL Configuration clientId property name*/,
   C7F2A8E14B9D4E6FA3015D8B62C9E47A /*cryptoSecretKey*/
}

export const guids = new Map<GUID_, string>([
   [GUID_.E3E990DC900441ECB664E9043B9A77B7, 'Client-Id-EE8289B486034E60'      /*serviceLayerClientIdHeaderName*/],
   [GUID_.F4D970E7D2214F33B390649AA5946C1E, 'Client-Secret-EE8289B486034E60'  /*serviceLayerClientSecretHeaderName*/],
   [GUID_.B8C119E38553467B8ED361CB1AC821C5, 'clientId'                        /*MSAL Configuration clientId property name*/],
   [GUID_.C7F2A8E14B9D4E6FA3015D8B62C9E47A, 'cryptoSecretKey'                 /*cryptoSecretKey property name*/]
])
